export default __webpack_public_path__ + "static/media/angers6.76833ca7.jpg";